<template>
  <header class="admin-topbar">
    <div class="topbar-left">
      <button class="toggle-sidebar-btn" @click="appStore.toggleSidebar" title="Toggle Sidebar">
        <el-icon><Fold v-if="isSidebarActive" /><Expand v-else /></el-icon>
      </button>

      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/admin' }">{{ t('topbar.home') }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="currentRouteTitle">{{ currentRouteTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="topbar-right">
      <!-- Language Switcher -->
      <el-dropdown @command="handleLangCommand" trigger="click">
        <el-button size="small" plain>
          {{ appStore.currentLang === 'ru' ? '🇷🇺 Русский' : '🇹🇲 Türkmençe' }}
          <el-icon class="el-icon--right"><ArrowDown /></el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="tk">🇹🇲 Türkmençe</el-dropdown-item>
            <el-dropdown-item command="ru">🇷🇺 Русский</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <!-- User Profile Dropdown -->
      <el-dropdown trigger="click" @command="handleUserCommand">
        <div class="user-profile-btn">
          <img :src="userAvatar" alt="Avatar" class="user-avatar" />
          <span>{{ authStore.user?.name || t('topbar.user') }}</span>
          <el-icon><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="site">
              <el-icon><View /></el-icon>
              <span>{{ t('topbar.site') }}</span>
            </el-dropdown-item>
            <el-dropdown-item command="password" divided>
              <el-icon><Key /></el-icon>
              <span>{{ t('topbar.changePassword') }}</span>
            </el-dropdown-item>
            <el-dropdown-item command="logout">
              <el-icon><SwitchButton /></el-icon>
              <span>{{ t('topbar.logout') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'
import { Fold, Expand, ArrowDown, View, Key, SwitchButton } from '@element-plus/icons-vue'

const route = useRoute()
const { t } = useI18n()
const authStore = useAuthStore()
const appStore = useAppStore()

const currentRouteTitle = computed(() => route.meta.title as string || '')

const isSidebarActive = computed(() => {
  if (typeof window !== 'undefined' && window.innerWidth <= 768) {
    return appStore.isMobileSidebarOpen
  }
  return !appStore.isSidebarCollapsed
})

const userAvatar = computed(() => {
  return authStore.user?.avatarUrl || '/img/favicon-32x32.png'
})

function handleLangCommand(lang: 'tk' | 'ru') {
  appStore.setLanguage(lang)
}

function handleUserCommand(command: string) {
  if (command === 'logout') {
    authStore.logout()
  } else if (command === 'password') {
    window.location.href = '/Identity/Account/Manage/ChangePassword'
  } else if (command === 'site') {
    window.open('/welcome', '_blank')
  }
}
</script>
